if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
					console.log('Cart Update')
					const event = new Event('cart-updated');
					this.dispatchEvent(event);
                    updateTotalRegularPrice();
                    //initializeStoreCredit();
				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));

			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}
// document.querySelectorAll('.store-credit-icon').forEach(function(el) {
//   el.addEventListener('click', function() {
//     window.location.reload();
//   });
// });

// method for apps to tap into and refresh the cart
function initializeStoreCredit() {
  console.log('initialize Store Credit')
  const storeCreditInput = document.getElementById('store-credit-amount');
  //const availableBalance = parseFloat(storeCreditInput.dataset.maxValue) || 0;
  const availableBalance = parseFloat(storeCreditInput.value) || 0;
  const cartTotal = parseFloat(storeCreditInput.dataset.totalValue) || 0;

  // Set the initial value based on available balance and cart total
  const smallestValue = Math.min(availableBalance, cartTotal);
  storeCreditInput.value = smallestValue.toFixed(2);
   // Trigger the input event programmatically
  document.querySelector('.store-credit-icon').addEventListener('click', function() {
      const storeCreditInput = document.getElementById('store-credit-amount');
      const storeCreditInput1 = storeCreditInput.getAttribute('data-min-value');
      storeCreditInput.value = storeCreditInput1;
      window.updateRemainingBalance();
    });
  storeCreditInput.addEventListener('input', updateRemainingBalance);
  storeCreditInput.addEventListener('input', toggleButtons);
  document.getElementById('apply-credit-btn-cart').addEventListener('click',manageCheckoutWithStoreCredit);
  if (typeof window.updateRemainingBalance === 'function') {

    window.updateRemainingBalance();

  }
  if (typeof window.toggleButtons === 'function') {

    window.toggleButtons();

  }
  // Add an event listener for changes to store credit input
}

if ( ! window.refreshCart ) {
    console.log('Cart Refresh')
	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			initializeStoreCredit();
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}




 
// Merge productIds and quantities into an object array
//window.customer.purchasedProducts = window.customer.productIds.map((id, index) => ({
//  productId: id,
//  quantity: parseInt(window.customer.vPurchaseProductQuantity[index] || 0)
//}));

// Show customer info (for debugging)
//alert("Customer Info:\n" + JSON.stringify(window.customer, null, 2));

// Show the loader while fetching cart data
//document.getElementById("checkout-custom-loader").style.display = "inline-block";

// Function to apply custom discount logic
// function applyCustomDiscountLogic(cartData) {
//   const purchasedProducts = window.customer.purchasedProducts || [];
//   const marketHandle = Shopify?.market?.handle || ""; // Shopify market handle
//   const customerDiscountSpecial = 30;

//   const discount_amount = customerDiscountSpecial;
//   const discount_amount2 = marketHandle === "australia" ? customerDiscountSpecial + 30 : customerDiscountSpecial;

//   let updatedPricesSummary = "";

//   cartData.items.forEach((item, index) => {
//     const productId = item.product_id.toString();
//     const quantity = item.quantity;
//     const price = item.price; // in cents
//     const purchased = purchasedProducts.find(p => p.productId === productId);
//     const purchasedQty = purchased ? purchased.quantity : 0;

//     const totalAfterThis = purchasedQty + quantity;

//     let discountedQty = 0;
//     let fullPriceQty = quantity;

//     if (totalAfterThis <= 5) {
//       discountedQty = quantity;
//       fullPriceQty = 0;
//     } else {
//       discountedQty = Math.max(0, 5 - purchasedQty);
//       fullPriceQty = quantity - discountedQty;
//     }

//     const effectiveDiscount = marketHandle === "australia" ? discount_amount2 : discount_amount;
//     const discountedPricePerUnit = price - Math.round(price * effectiveDiscount / 100);
//     const totalDiscounted = discountedQty * discountedPricePerUnit;
//     const totalFullPrice = fullPriceQty * price;
//     const finalPrice = totalDiscounted + totalFullPrice;

//     const finalPriceFormatted = (finalPrice / 100).toLocaleString('en-US', {
//       style: 'currency',
//       currency: cartData.currency || 'AUD'
//     });

//     const originalLinePriceFormatted = (item.original_line_price / 100).toLocaleString('en-US', {
//       style: 'currency',
//       currency: cartData.currency || 'AUD'
//     });

//     updatedPricesSummary += `Item ${index + 1}:\n`;
//     updatedPricesSummary += ` - Title: ${item.title}\n`;
//     updatedPricesSummary += ` - Qty: ${quantity}\n`;
//     updatedPricesSummary += ` - Final Price: ${finalPriceFormatted}\n`;
//     updatedPricesSummary += ` - Original Price: ${originalLinePriceFormatted}\n\n`;

//     // Update item price in DOM
//     const priceContainers = document.querySelectorAll(".cart-item__total");
//     const priceContainer = priceContainers[index];

//     if (priceContainer) {
//       if (discountedQty > 0 && discountedQty < quantity) {
//         priceContainer.innerHTML = `
//           <strong>${finalPriceFormatted}</strong>
//           <span class="visually-hidden">Original Price</span>
//           <span><del>${originalLinePriceFormatted}</del></span>
//         `;
//       } else if (discountedQty === quantity) {
//         priceContainer.innerHTML = `
//           <strong>${finalPriceFormatted}</strong>
//           <span class="visually-hidden">Original Price</span>
//           <span><del>${originalLinePriceFormatted}</del></span>
//         `;
//       } else {
//         priceContainer.innerHTML = `<strong>${finalPriceFormatted}</strong>`;
//       }
//     }
//   });

//   // Calculate the final subtotal
//   const totalFinalPrice = cartData.items.reduce((total, item) => {
//     const productId = item.product_id.toString();
//     const quantity = item.quantity;
//     const price = item.price;

//     const purchased = purchasedProducts.find(p => p.productId === productId);
//     const purchasedQty = purchased ? purchased.quantity : 0;
//     const totalAfterThis = purchasedQty + quantity;

//     let discountedQty = totalAfterThis <= 5 ? quantity : Math.max(0, 5 - purchasedQty);
//     let fullPriceQty = quantity - discountedQty;

//     const effectiveDiscount = marketHandle === "australia" ? discount_amount2 : discount_amount;
//     const discountedPricePerUnit = price - Math.round(price * effectiveDiscount / 100);

//     return total + (discountedQty * discountedPricePerUnit + fullPriceQty * price);
//   }, 0);

//   const finalTotalFormatted = (totalFinalPrice / 100).toLocaleString('en-US', {
//     style: 'currency',
//     currency: cartData.currency || 'AUD'
//   });

//   // Update Subtotal
//   const subtotalContainer = document.querySelector(".cart__subtotal, .totals__subtotal, .cart-subtotal");
//   if (subtotalContainer) {
//     subtotalContainer.innerHTML = `<strong>${finalTotalFormatted}</strong>`;
//   }

//   // Update Store Credit
//   const storeCreditElement = document.querySelector("#store-credit-amount"); // Adjust selector
//   if (storeCreditElement) {
//     storeCreditElement.innerHTML = `<strong>${finalTotalFormatted}</strong>`;
//   }

//   // Update Total
//   const totalAmountElement = document.querySelector("#remaining_amount"); // Adjust selector
//   if (totalAmountElement) {
//     totalAmountElement.innerHTML = `<strong>${finalTotalFormatted}</strong>`;
//   }

//   // Final debug summary
//   alert("Updated Cart Prices:\n\n" + updatedPricesSummary);
// }

// Check if cart content has changed (for example, item added/removed/quantity changed)
// let previousCartData = null;
// function checkCartChange() {
//   fetch("/cart.js")
//     .then(response => response.json())
//     .then(cartData => {
//       if (!previousCartData || JSON.stringify(cartData.items) !== JSON.stringify(previousCartData.items)) {
//         previousCartData = cartData;
//         applyCustomDiscountLogic(cartData); // Pass cartData to the function
//       }
//     })
//     .catch((err) => {
//       console.error("Error checking cart changes:", err);
//     });
// }

// Call on page load
// checkCartChange();

// // Reapply discount logic when cart updates
// const cartContainer = document.querySelector(".cart__items"); // Adjust if needed
// const observer = new MutationObserver(() => {
//   console.log("Cart changed - reapplying discount logic");
//   checkCartChange();
// });

// if (cartContainer) {
//   observer.observe(cartContainer, { childList: true, subtree: true });
// }
  // Merge productIds and quantities into object array

   // window.customer.purchasedProducts = window.customer.productIds.map((id, index) => ({
   //    productId: id,
   //    quantity: parseInt(window.customer.vPurchaseProductQuantity[index] || 0)
   //  }));

    // setTimeout(function () {
    //   updateTotalRegularPrice();
    // }, 500); // Delay to allow quantity change to reflect





